"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessTokenCustomStrategy = void 0;
var customMethod;
var execute = function () {
    return customMethod().then(function (applicationAccessToken) {
        return {
            applicationAccessToken: applicationAccessToken,
            deviceRefreshToken: undefined,
        };
    });
};
var setCustomMethod = function (newMethod) {
    customMethod = newMethod;
};
var getCustomMethod = function () {
    return customMethod;
};
exports.getAccessTokenCustomStrategy = {
    execute: execute,
    getCustomMethod: getCustomMethod,
    setCustomMethod: setCustomMethod,
};
